module.exports = __webpack_public_path__ + "static/media/type-movie.3bb6d40a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/type-movie.svg
// module id = 105
// module chunks = 0